import './Main/admin/1Controllers.js';
import './Main/admin/2Routes.js';
import './Main/admin/adminCACM/1Controllers.js';
import './Main/admin/adminCACM/2Routes.js';
import './Main/admin/adminCACM/3Service.js';
import './Main/admin/adminCACM/AdminCACMController.js';
import './Main/admin/AdminController.js';
import './Main/admin/adminGovernanceProcess/1Controllers.js';
import './Main/admin/adminGovernanceProcess/2Routes.js';
import './Main/admin/adminGovernanceProcess/3Service.js';
import './Main/admin/adminGovernanceProcess/AdminGovernanceProcessListController.js';
import './Main/admin/adminGovernanceProcess/EditGovernanceProcessController.js';
import './Main/admin/adminODD/1Controllers.js';
import './Main/admin/adminODD/2Routes.js';
import './Main/admin/adminODD/3Service.js';
import './Main/admin/adminODD/AdminODDController.js';
import './Main/admin/adminReferenceData/1Controllers.js';
import './Main/admin/adminReferenceData/2Routes.js';
import './Main/admin/adminReferenceData/3Service.js';
import './Main/admin/adminReferenceData/4Service.js';
import './Main/admin/adminReferenceData/AdminReferenceDataController.js';
import './Main/admin/travelGovernanceProcess/1Controllers.js';
import './Main/admin/travelGovernanceProcess/2Routes.js';
import './Main/admin/travelGovernanceProcess/3TravelService.js';
import './Main/admin/travelGovernanceProcess/TravelGovernanceProcessEditController.js';
import './Main/admin/travelGovernanceProcess/TravelGovernanceProcessListController.js';
import './Main/aric/1Controllers.js';
import './Main/aric/2Routes.js';
import './Main/aric/3Service.js';
import './Main/aric/AricController.js';
import './Main/aric/aricControlOwnerCardDirective.js';
import './Main/aric/AricControlOwnersListController.js';
import './Main/aric/AricControlsByOwnerController.js';
import './Main/aric/AricWithNoActiveProcessController.js';
import './Main/aric/certification/1Module.js';
import './Main/aric/certification/2Routes.js';
import './Main/aric/certification/CertificationController.js';
import './Main/aric/certification/ControlCertificationController.js';
import './Main/aric/certification/OwnerAssessmentController.js';
import './Main/aric/certification/OwnerCertificationController.js';
import './Main/aric/certification/OwnerCertificationWelcomeController.js';
import './Main/auditMandate/1Module.js';
import './Main/auditMandate/2Routes.js';
import './Main/auditMandate/AuditMandateAddController.js';
import './Main/auditMandate/AuditMandateEditController.js';
import './Main/auditMandate/AuditMandateObservationsListController.js';
import './Main/auditMandate/AuditMandatesListController.js';
import './Main/BCM/1Controllers.js';
import './Main/BCM/2Routes.js';
import './Main/BCM/BIABUOwnerEditController.js';
import './Main/BCM/BIAContactDetailsDirective.js';
import './Main/BCM/BIAProfileEditBreadcrumbController.js';
import './Main/BCM/BIAProfileEditController.js';
import './Main/BCM/BIAProfileIntroductionController.js';
import './Main/BCM/BIAProfileListController.js';
import './Main/BCM/BIAProfileSummaryController.js';
import './Main/BCM/BIAResponsibilityEditForBUOwnerController.js';
import './Main/businessPlan/explorer/1Module.js';
import './Main/businessPlan/explorer/2Routes.js';
import './Main/businessPlan/explorer/BusinessPlanController.js';
import './Main/cacm/2Routes.js';
import './Main/cacm/CacmController.js';
import './Main/cacm/events/1Module.js';
import './Main/cacm/events/2Routes.js';
import './Main/cacm/events/CacmEventEditController.js';
import './Main/grcEdit/2Routes.js';
import './Main/grcEdit/actionPlan/1Module.js';
import './Main/grcEdit/actionPlan/2Routes.js';
import './Main/grcEdit/actionPlan/ActionPlanEditController.js';
import './Main/grcEdit/actionPlanCriteria/1Module.js';
import './Main/grcEdit/actionPlanCriteria/2Routes.js';
import './Main/grcEdit/actionPlanCriteria/ActionPlanCriteriaEditController.js';
import './Main/grcEdit/businessPlan/initiative/1Module.js';
import './Main/grcEdit/businessPlan/initiative/2Routes.js';
import './Main/grcEdit/businessPlan/initiative/DeliverableEditController.js';
import './Main/grcEdit/businessPlan/initiative/InitiativeAddController.js';
import './Main/grcEdit/businessPlan/initiative/InitiativeEditController.js';
import './Main/grcEdit/committee/1Module.js';
import './Main/grcEdit/committee/2Routes.js';
import './Main/grcEdit/committee/CommitteeAddController.js';
import './Main/grcEdit/committee/CommitteeEditController.js';
import './Main/grcEdit/control/1Module.js';
import './Main/grcEdit/control/2Routes.js';
import './Main/grcEdit/control/ControlAddController.js';
import './Main/grcEdit/control/ControlEditController.js';
import './Main/grcEdit/control/ControlHistoryController.js';
import './Main/grcEdit/control/ControlObservationListController.js';
import './Main/grcEdit/control/ControlRelatedRisksController.js';
import './Main/grcEdit/control/ControlTestController.js';
import './Main/grcEdit/control/ControlTestObservationListController.js';
import './Main/grcEdit/corporateRole/1Module.js';
import './Main/grcEdit/corporateRole/2Routes.js';
import './Main/grcEdit/corporateRole/CorporateRoleAddController.js';
import './Main/grcEdit/corporateRole/CorporateRoleEditController.js';
import './Main/grcEdit/glossaryTerm/1Module.js';
import './Main/grcEdit/glossaryTerm/2Routes.js';
import './Main/grcEdit/glossaryTerm/GlossaryTermAddController.js';
import './Main/grcEdit/glossaryTerm/GlossaryTermEditController.js';
import './Main/grcEdit/observation/1Module.js';
import './Main/grcEdit/observation/2Routes.js';
import './Main/grcEdit/observation/ObservationEditController.js';
import './Main/grcEdit/observation/ObservationRecommendationAddController.js';
import './Main/grcEdit/recommendation/1Module.js';
import './Main/grcEdit/recommendation/2Routes.js';
import './Main/grcEdit/recommendation/RecommendationEditController.js';
import './Main/grcEdit/risk/1Module.js';
import './Main/grcEdit/risk/2Routes.js';
import './Main/grcEdit/risk/RiskEditController.js';
import './Main/grcEdit/risk/RiskRelatedControlsController.js';
import './Main/grcEdit/risk/RiskRelatedRiskEventsController.js';
import './Main/grcEdit/risk/RiskSubRisksController.js';
import './Main/grcEdit/risk/ViewHistoricOnRiskController.js';
import './Main/grcEdit/riskEvent/1Module.js';
import './Main/grcEdit/riskEvent/2Routes.js';
import './Main/grcEdit/riskEvent/RiskEventEditController.js';
import './Main/grcEdit/riskEvent/RiskEventRelatedRisksController.js';
import './Main/home/1Controllers.js';
import './Main/home/2Routes.js';
import './Main/home/dashboard/1Controllers.js';
import './Main/home/dashboard/AricController.js';
import './Main/home/dashboard/BusinessPlanningController.js';
import './Main/home/dashboard/CACMEventsController.js';
import './Main/home/dashboard/DashboardActionPlanUpdateStatusController.js';
import './Main/home/dashboard/DashboardHomeController.js';
import './Main/home/dashboard/DashboardInitiativeManagementController.js';
import './Main/home/dashboard/DashboardInitiativeUpdateStatusController.js';
import './Main/home/dashboard/ItemsSummaryController.js';
import './Main/home/dashboard/RiskSelfAssessmentController.js';
import './Main/home/HomeController.js';
import './Main/home/HomeWithSolrController.js';
import './Main/home/myTasks/1Controllers.js';
import './Main/home/myTasks/ActionPlanStatusUpdateController.js';
import './Main/home/myTasks/ControlCertificationController.js';
import './Main/home/myTasks/InitiativeCreationEditController.js';
import './Main/home/myTasks/InitiativeUpdateStatusAssessmentController.js';
import './Main/home/myTasks/MyTasksBIAProfileMgmtController.js';
import './Main/home/myTasks/MyTasksController.js';
import './Main/home/myTasks/PendingReviewRiskSelfAssessmentController.js';
import './Main/home/myTasks/RiskSelfAssessmentController.js';
import './Main/home/RootController.js';
import './Main/initiativeUpdateStatus/1Controllers.js';
import './Main/initiativeUpdateStatus/2Routes.js';
import './Main/initiativeUpdateStatus/assess/2Routes.js';
import './Main/initiativeUpdateStatus/assess/ByInitiativeAssessmentController.js';
import './Main/initiativeUpdateStatus/assess/ByInitiativeDeliverablesController.js';
import './Main/initiativeUpdateStatus/assess/ByQuarterDeliverablesController.js';
import './Main/initiativeUpdateStatus/assess/DeliverablesListByQuarterController.js';
import './Main/initiativeUpdateStatus/assess/InitiativeAssessmentAssessController.js';
import './Main/initiativeUpdateStatus/assess/InitiativesListController.js';
import './Main/initiativeUpdateStatus/assess/InitiativeUpdateStatusAssessController.js';
import './Main/initiativeUpdateStatus/assess/planDeliverableAssessmentDirective.js';
import './Main/initiativeUpdateStatus/InitiativeUpdateStatusController.js';
import './Main/initiativeUpdateStatus/InitiativeUpdateStatusEligibleForAssessmentController.js';
import './Main/initiativeUpdateStatus/InitiativeUpdateStatusOwnerCardDirective.js';
import './Main/initiativeUpdateStatus/InitiativeUpdateStatusOwnersListController.js';
import './Main/initiativeUpdateStatus/ownerWithInitiativesDirective.js';
import './Main/initiativeUpdateStatus/review/2Routes.js';
import './Main/initiativeUpdateStatus/review/3Service.js';
import './Main/initiativeUpdateStatus/review/backToDashboardDirective.js';
import './Main/initiativeUpdateStatus/review/ByQuarterDeliverablesController.js';
import './Main/initiativeUpdateStatus/review/DeliverablesListByQuarterController.js';
import './Main/initiativeUpdateStatus/review/InitiativeListController.js';
import './Main/initiativeUpdateStatus/review/InitiativeUpdateStatusReviewController.js';
import './Main/initiativeUpdateStatus/review/planDeliverableReviewDirective.js';
import './Main/initiativeUpdateStatus/review/ReviewDeliverablesByInitiativeController.js';
import './Main/initiativeUpdateStatus/review/ReviewInitiativeAssessmentController.js';
import './Main/initiativeUpdateStatus/review/ReviewInitiativeController.js';
import './Main/navigation/1Controllers.js';
import './Main/navigation/NavigationController.js';
import './Main/odd/2Routes.js';
import './Main/odd/campaignStatusMgmt/1Module.js';
import './Main/odd/campaignStatusMgmt/2Routes.js';
import './Main/odd/campaignStatusMgmt/ODDExternalPartiesController.js';
import './Main/odd/externalPartyEdit/1Module.js';
import './Main/odd/externalPartyEdit/2Routes.js';
import './Main/odd/externalPartyEdit/ODDCampaignEditController.js';
import './Main/odd/externalPartyEdit/ODDCampaignInviteDetailsEditController.js';
import './Main/odd/externalPartyEdit/ODDCampaignObservationListEditController.js';
import './Main/odd/externalPartyEdit/ODDCampaignQuestionnaireAddController.js';
import './Main/odd/externalPartyEdit/ODDCampaignQuestionnaireEditController.js';
import './Main/odd/externalPartyEdit/ODDCampaignQuestionnaireListEditController.js';
import './Main/odd/externalPartyEdit/ODDCampaignQuestionnaireSectionAddController.js';
import './Main/odd/externalPartyEdit/ODDCampaignQuestionnaireSectionListEditController.js';
import './Main/odd/externalPartyEdit/ODDExternalPartyAddController.js';
import './Main/odd/externalPartyEdit/ODDExternalPartyEditController.js';
import './Main/odd/ODDBusinessUnitController.js';
import './Main/odd/questionnaireTemplatesEdit/1Module.js';
import './Main/odd/questionnaireTemplatesEdit/2Routes.js';
import './Main/odd/questionnaireTemplatesEdit/QuestionnaireTemplateComponentListEditController.js';
import './Main/odd/questionnaireTemplatesEdit/QuestionnaireTemplateEditController.js';
import './Main/odd/questionnaireTemplatesEdit/QuestionnaireTemplateQuestionEditController.js';
import './Main/odd/questionnaireTemplatesEdit/QuestionnaireTemplateSectionEditController.js';
import './Main/odd/questionnaireTemplatesEdit/QuestionnaireTemplateSectionListEditController.js';
import './Main/odd/questionnaireTemplatesEdit/QuestionnaireTemplatesListController.js';
import './Main/odd/questionnaireTemplatesEdit/QuestionnaireTemplateStaticTextEditController.js';
import './Main/odd/surveyCampaigns/1Module.js';
import './Main/odd/surveyCampaigns/2Routes.js';
import './Main/odd/surveyCampaigns/CampaignRespondentListController.js';
import './Main/odd/surveyCampaigns/SurveyCampaignAddController.js';
import './Main/odd/surveyCampaigns/SurveyCampaignComponentListEditController.js';
import './Main/odd/surveyCampaigns/SurveyCampaignEditController.js';
import './Main/odd/surveyCampaigns/SurveyCampaignInviteDetailsEditController.js';
import './Main/odd/surveyCampaigns/SurveyCampaignListController.js';
import './Main/odd/surveyCampaigns/SurveyCampaignQuestionEditController.js';
import './Main/odd/surveyCampaigns/surveyCampaignQuestionnaireEditController.js';
import './Main/odd/surveyCampaigns/surveyCampaignQuestionnaireListEditController.js';
import './Main/odd/surveyCampaigns/SurveyCampaignQuestionnaireSectionEditController.js';
import './Main/odd/surveyCampaigns/SurveyCampaignQuestionnaireStaticTextEditController.js';
import './Main/odd/surveyCampaigns/SurveyCampaignSectionListEditController.js';
import './Main/procedure/1Controllers.js';
import './Main/procedure/2Routes.js';
import './Main/procedure/ProcedureController.js';
import './Main/procedure/ProcedureEditAccessRightsController.js';
import './Main/procedure/ProcedureEditMetadataController.js';
import './Main/procedure/ProcedureEditReviewersController.js';
import './Main/procedure/ProcedureMetadataReviewController.js';
import './Main/procedure/ProcedureRedirectionController.js';
import './Main/procedure/ProcedureSectionListController.js';
import './Main/procedure/ProcedureSectionListEditController.js';
import './Main/procedure/responsibility/ProcedureResponsibilityEditController.js';
import './Main/procedure/sectionBlock/ProcedureSectionBlockEditController.js';
import './Main/procedure/sectionBlock/ProcedureSectionBlockViewController.js';
import './Main/procedure/sectionBlock/ProcedureSectionReviewSectionController.js';
import './Main/recom/1Controllers.js';
import './Main/recom/2Routes.js';
import './Main/recom/GovernanceProcessEditController.js';
import './Main/recom/GovernanceProcessListController.js';
import './Main/recomActionPlanStatusUpdate/1Controllers.js';
import './Main/recomActionPlanStatusUpdate/2Routes.js';
import './Main/recomActionPlanStatusUpdate/ActionPlanUpdateStatusController.js';
import './Main/recomActionPlanStatusUpdate/ActionPlanUpdateStatusOwnerCardDirective.js';
import './Main/recomActionPlanStatusUpdate/ActionPlanUpdateStatusOwnerListController.js';
import './Main/recomActionPlanStatusUpdate/ActionPlanUpdateStatusSelectAssessmentController.js';
import './Main/recomActionPlanStatusUpdate/ActionPlanUpdateStatusValidateController.js';
import './Main/recomActionPlanStatusUpdate/assess/1Controllers.js';
import './Main/recomActionPlanStatusUpdate/assess/2Routes.js';
import './Main/recomActionPlanStatusUpdate/assess/actionPlanAsssessmentSelectorDirective.js';
import './Main/recomActionPlanStatusUpdate/assess/ActionPlanController.js';
import './Main/recomActionPlanStatusUpdate/assess/ActionPlansListController.js';
import './Main/recomActionPlanStatusUpdate/assess/ByActionPlanAssessmentController.js';
import './Main/recomActionPlanStatusUpdate/assess/ByActionPlanController.js';
import './Main/recomActionPlanStatusUpdate/assess/ByActionPlanCriteriasController.js';
import './Main/recomActionPlanStatusUpdate/assess/ByQuarterController.js';
import './Main/recomActionPlanStatusUpdate/assess/criteriaAssessmentDirective.js';
import './Main/recomActionPlanStatusUpdate/assess/CriteriasListByQuarterController.js';
import './Main/recomActionPlanStatusUpdate/assess/UpdateStatusAssessController.js';
import './Main/recomActionPlanStatusUpdate/GovernanceProcessEditController.js';
import './Main/recomActionPlanStatusUpdate/ownerSendReminderModalController.js';
import './Main/recomActionPlanStatusUpdate/review/1Controllers.js';
import './Main/recomActionPlanStatusUpdate/review/2Routes.js';
import './Main/recomActionPlanStatusUpdate/review/ActionPlanController.js';
import './Main/recomActionPlanStatusUpdate/review/actionPlanReviewSelectorDirective.js';
import './Main/recomActionPlanStatusUpdate/review/ActionPlansListController.js';
import './Main/recomActionPlanStatusUpdate/review/backToDashboardDirective.js';
import './Main/recomActionPlanStatusUpdate/review/ByActionPlanAssessmentController.js';
import './Main/recomActionPlanStatusUpdate/review/ByActionPlanController.js';
import './Main/recomActionPlanStatusUpdate/review/ByActionPlanCriteriasController.js';
import './Main/recomActionPlanStatusUpdate/review/ByQuarterController.js';
import './Main/recomActionPlanStatusUpdate/review/criteriaReviewDirective.js';
import './Main/recomActionPlanStatusUpdate/review/CriteriasListByQuarterController.js';
import './Main/recomActionPlanStatusUpdate/review/UpdateStatusReviewController.js';
import './Main/recomActionPlanStatusUpdate/WelcomeController.js';
import './Main/recomActionPlanStatusUpdate/WithNoActiveProcessController.js';
import './Main/riskSelfAssessment/assess/1Controllers.js';
import './Main/riskSelfAssessment/assess/2Routes.js';
import './Main/riskSelfAssessment/assess/3Service.js';
import './Main/riskSelfAssessment/assess/AssessController.js';
import './Main/riskSelfAssessment/assess/AssessFinalQuestionsController.js';
import './Main/riskSelfAssessment/assess/AssessPreliminaryQuestionsController.js';
import './Main/riskSelfAssessment/assess/AssessRiskController.js';
import './Main/riskSelfAssessment/assess/AssessSummaryController.js';
import './Main/riskSelfAssessment/assess/AssessWelcomeController.js';
import './Main/riskSelfAssessment/list/1Controllers.js';
import './Main/riskSelfAssessment/list/2Routes.js';
import './Main/riskSelfAssessment/list/3Service.js';
import './Main/riskSelfAssessment/list/ListController.js';
import './Main/riskSelfAssessment/list/rcsaStatusAssessorCardDirective.js';
import './Main/riskSelfAssessment/review/1Controllers.js';
import './Main/riskSelfAssessment/review/2Routes.js';
import './Main/riskSelfAssessment/review/3Service.js';
import './Main/riskSelfAssessment/review/finalRatingsDirective.js';
import './Main/riskSelfAssessment/review/keyRiskToReviewDirective.js';
import './Main/riskSelfAssessment/review/preFinalRatingsDirective.js';
import './Main/riskSelfAssessment/review/ReviewByAssessorController.js';
import './Main/riskSelfAssessment/review/ReviewByAssessorRiskController.js';
import './Main/riskSelfAssessment/review/ReviewByAssessorSummaryController.js';
import './Main/riskSelfAssessment/review/ReviewFinalQuestionsController.js';
import './Main/riskSelfAssessment/review/ReviewPreliminaryQuestionsController.js';
import './Main/riskSelfAssessment/review/ReviewRiskController.js';
import './Main/riskSelfAssessment/review/ReviewRiskRatingsController.js';
import './Main/riskSelfAssessment/review/ReviewTopRiskListController.js';
import './Main/riskSelfAssessment/review/topRiskToReviewDirective.js';
import './Main/search/1Controllers.js';
import './Main/search/2Routes.js';
import './Main/search/SearchController.js';
import './Main/signalr/1Controllers.js';
import './Main/signalr/2Routes.js';
import './Main/signalr/3Service.js';
import './Main/signalr/ChatController.js';
import './Main/staticHtmlPage/1Controllers.js';
import './Main/staticHtmlPage/2Routes.js';
import './Main/staticHtmlPage/3services.js';
import './Main/staticHtmlPage/StaticHtmlPageController.js';
import './Main/survey/1Controllers.js';
import './Main/survey/2Routes.js';
import './Main/survey/3Service.js';
import './Main/survey/AvailableSurveysController.js';
import './Main/survey/campaign/1Controllers.js';
import './Main/survey/campaign/2Routes.js';
import './Main/survey/campaign/3Service.js';
import './Main/survey/campaign/CampaignController.js';
import './Main/survey/campaign/CampaignListController.js';
import './Main/survey/campaign/CampaignPartAddQuestionController.js';
import './Main/survey/campaign/CampaignPartBuilderController.js';
import './Main/survey/campaign/campaignPartCardDirective.js';
import './Main/survey/campaign/CampaignPartsController.js';
import './Main/survey/campaign/campaignQuestionCardDirective.js';
import './Main/survey/campaign/campaignRespondentCardDirective.js';
import './Main/survey/campaign/CampaignSettingsController.js';
import './Main/survey/campaign/campaignVisualComponentCardDirective.js';
import './Main/survey/campaign/NewCampaignController.js';
import './Main/survey/campaign/owner/2Routes.js';
import './Main/survey/campaign/owner/campaignOwnerCardDirective.js';
import './Main/survey/campaign/owner/CampaignOwnersListController.js';
import './Main/survey/campaign/owner/CampaignSelectNewOwnerController.js';
import './Main/survey/campaign/SelectNewRespondentController.js';
import './Main/survey/campaign/SidebarCampaignController.js';
import './Main/survey/campaign/SidebarCampaignPartBuilderController.js';
import './Main/survey/SidebarSurveyRespondentController.js';
import './Main/survey/surveyContextService.js';
import './Main/survey/SurveyController.js';
import './Main/survey/SurveyNotAvailableController.js';
import './Main/survey/surveyQuestionDirective.js';
import './Main/survey/SurveyQuestionFreeTextDefaultController.js';
import './Main/survey/SurveyQuestionMultipleChoiceController.js';
import './Main/survey/SurveyQuestionRankingController.js';
import './Main/survey/SurveyRespondentController.js';
import './Main/survey/SurveyRespondentPageController.js';
import './Main/visualGuidelines/1Controllers.js';
import './Main/visualGuidelines/2Routes.js';
import './Main/visualGuidelines/component/1Controllers.js';
import './Main/visualGuidelines/component/2Routes.js';
import './Main/visualGuidelines/component/ComponentController.js';
import './Main/visualGuidelines/component/ConfirmClickController.js';
import './Main/visualGuidelines/component/DisplayPersonController.js';
import './Main/visualGuidelines/component/FallbackSrcController.js';
import './Main/visualGuidelines/component/PickerDepartmentRiskController.js';
import './Main/visualGuidelines/component/PickerPersonController.js';
import './Main/visualGuidelines/style/1Controllers.js';
import './Main/visualGuidelines/style/2Routes.js';
import './Main/visualGuidelines/style/3Service.js';
import './Main/visualGuidelines/style/StyleController.js';
import './Main/visualGuidelines/style/StyleIconsController.js';
import './Main/visualGuidelines/VisualGuidelinesController.js';
